import React from "react";
import Navbar from "../../components/navbar/navbar";
import job_interview from '../../assets/images/job_interview.png';
import { Link } from "react-router-dom";
import icon1 from './service_icons/icon1.png'
import icon2 from './service_icons/icon2.png'
import icon3 from './service_icons/icon3.png'
import icon4 from './service_icons/icon4.png'
// import servicebanner from './service_banner.png'
function Auction_Negotiation(){
    return(
        <>
        <Navbar/>
        <div data-aos="fade-in">
        <div className="services_banner services_banner4">
            <div>
                <h2>Auction & Negotiation Services</h2>
                <p>
                    Navigating the property market can be overwhelming, but with Buyers Galaxy, it doesn’t have to
                    be. Our Home Buying Services are designed to make your journey to homeownership seamless,
                    informed, and stress-free. Whether you're a first-time buyer, upgrading to your dream home,
                    or searching for the perfect investment, we provide end-to-end support tailored to your
                    unique goals.
                </p>
                <Link to="/contact" className="btn">Contact Us</Link>
            </div>
        </div>
        <div className="service_offer">
            <h2 className="offer">What We Offer</h2>
            <div className="offer_blocks">
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon2} alt="" />
                    </div>
                    <div>
                        <h5>Expert Auction Representation</h5>
                        <p>As auction specialists, we guide you with strategy and representation to keep you calm, focused, and in control.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon1} alt="" />
                    </div>
                    <div>
                        <h5>Masterful Negotiation</h5>
                        <p>Our negotiation expertise secures favorable terms, avoiding overpaying and ensuring every detail works to your advantage.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon3} alt="" />
                    </div>
                    <div>
                        <h5>Preparation and Strategy</h5>
                        <p>We research sales, values, trends, and vendor motivations to ensure informed decisions before auctions or negotiations.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon4} alt="" />
                    </div>
                    <div>
                        <h5>End-to-End Support</h5>
                        <p>From pre-auction advice and strategy to post-auction negotiations, we provide support at every stage, ensuring you secure your property at the best possible price.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
            </div>
        </div>
        <div className="services_info_bottom">
            <p>Discover Melbourne's no-go suburbs for Investment</p>
            <Link to='/download'>Download Now</Link>
        </div>
        <div className="services_info">
            <div className="service_img_detail">
                <h2>Why Choose Us?</h2>
                <p>At Buyers Galaxy, we don’t just help you buy a house—we help you find a place to call home or a strategic addition to your property portfolio. Our goal is to simplify the process, save you time, and maximize the value of your investment.</p>
                {/* <Link to="/contact" className="con-btn">Get a House Now</Link> */}
            </div>
            <img src={job_interview} alt="" />
        </div>
        <div className="services_details"></div>
        </div>
        </>
    );

}
export default Auction_Negotiation;